import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/components/Login.vue'
import Regist from '@/components/Regist.vue'
import PassWord from '@/components/PassWord.vue'
import ChangePassWord from '@/components/ChangePassWord.vue'
import UserInfo from '@/components/UserInfo.vue'
import ChangeTel from '@/components/ChangeTel.vue'
import UserIntro from '@/components/UserIntro.vue'
import SaveApply from '@/components/SaveApply.vue'
import MyApply from '@/components/MyApply.vue'
import MyInfo from '@/components/MyInfo.vue'
import BasicInfo from '@/components/BasicInfo.vue'
import JobExp from '@/components/JobExp.vue'
import FamilyGroup from '@/components/FamilyGroup.vue'
import EduExp from '@/components/EduExp.vue'
Vue.use(VueRouter)

  const routes = [
  {
    path: '/', //用户登录默认页
    name: 'Login',
    component: Login,
    meta:{
      title:"烟台传媒集团_用户登录"
    }
  },{
    path: '/Regist', //用户注册页
    name: 'Regist',
    component: Regist,
    meta:{
      title:"烟台传媒集团_用户注册"
    }
  },{
    path: '/PassWord', //忘记密码页
    name: 'PassWord',
    component: PassWord,
    meta:{
      title:"烟台传媒集团_忘记密码"
    }
  },{
    path: '/ChangePassWord',//修改密码页
    name: 'ChangePassWord',
    component: ChangePassWord,
    meta:{
      title:"烟台传媒集团_修改密码"
    }
  },{
    path: '/UserInfo', //用户登录成功页
    name: 'UserInfo',
    component: UserInfo,
    meta:{
      title:"烟台传媒集团_用户信息"
    }
  },{
    path: '/ChangeTel', //更改手机号
    name: 'ChangeTel',
    component: ChangeTel,
    meta:{
      title:"烟台传媒集团_更改手机号"
    }
  },{
    path: '/UserIntro', //用户完善资料页
    name: 'UserIntro',
    component: UserIntro,
    meta:{
      title:"烟台传媒集团_完善资料"
    }
  },{
    path: '/SaveApply', //职位申报页
    name: 'SaveApply',
    component: SaveApply,
    meta:{
      title:"烟台传媒集团_职位申报"
    }
  },{
    path: '/MyApply', //我申请的职位页
    name: 'MyApply',
    component: MyApply,
    meta:{
      title:"烟台传媒集团_申请的职位"
    }
  },{
    path: '/MyInfo', //查看个人资料
    name: 'MyInfo',
    component: MyInfo,
    meta:{
      title:"烟台传媒集团_查看资料"
    }
  },{
    path: '/BasicInfo', //个人基本资料
    name: 'BasicInfo',
    component: BasicInfo,
    meta:{
      title:"烟台传媒集团_基本资料"
    }
  },{
    path: '/EduExp', //个人教育经历
    name: 'EduExp',
    component: EduExp,
    meta:{
      title:"烟台传媒集团_教育经历"
    }
  },{
    path: '/JobExp', //个人工作经历
    name: 'JobExp',
    component: JobExp,
    meta:{
      title:"烟台传媒集团_工作经历"
    }
  },{
    path: '/FamilyGroup', //家庭关系
    name: 'FamilyGroup',
    component: FamilyGroup,
    meta:{
      title:"烟台传媒集团_家庭关系"
    }
  }


  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
